module.exports = __webpack_public_path__ + "img/nexteev-icone-principal.982fcd3e.svg";